import { Collapse } from "antd";
import CaretDown from "../../components/Icons/CaretDown";
import SectionWrapper from "../../components/SectionWrapper";

const SettingSection = () => {
    return (
        <SectionWrapper>
            <Collapse accordion={true} expandIconPosition={"right"} ghost expandIcon={() => <CaretDown style={{ transform: "rotate(-90deg)"}} />}>
                <Collapse.Panel header={<div className="text-theme font-18 fw-bold mb-3">General Settings</div>} key="1">
                    <div className="text-center font-24 text-theme my-3">Coming Soon</div>
                </Collapse.Panel>
                <Collapse.Panel header={<div className="text-theme font-18 fw-bold mb-3">Security Settings</div>} key="2">
                    <div className="text-center font-24 text-theme my-3">Coming Soon</div>
                </Collapse.Panel>
            </Collapse>
        </SectionWrapper>
    );
};

export default SettingSection;
